//window.Vue = require('vue');
import Vue from 'vue';

window.Vue = Vue;


window._ = require('lodash');
window.approve = require('approvejs');
window.$ = require('jquery');
window.jQuery = window.$;
window.Promise = require("bluebird");
window.Cookies = require("js-cookie");


require('./jquery-app.js'); //jquery 플러그인

// 날짜 라이브러리
import moment from 'moment';
window.moment = moment;

// 버전비교 라이브러리 (필요한데서 임포트해서 사용)
//import * as semver from 'semver';
//console.log(semver);

// AWS 라이브러리
var AWS = require('aws-sdk');
var uuid = require('uuid');



// lazyload
import * as lazySizes from 'lazysizes';

// vue datepicker
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
/**
 * vue-ctk-date-time-picker 이 es6 으로 작성되어있는데,
 * 그대로 node_modules 디렉토리안에 두고 import 하게되면,
 * npm run dev 할때는 괜찮은데, npm run prod 하게되면,
 * uglify-js 에서 es6을 처리하지 못하기때문에, 오류가나면서 빌드에 실패함.
 * (웹팩 babel 컴파일 설정이 node_modules 아래있는 js파일들은 es5로 변환하지 않도록 설정되어있다고함.
 *
 * 그래서, 해당 js파일을 assets/js 밑으로 이동해서 es6->es5 변환처리가 이루어지도록 함.
 */
import VueCtkDateTimePicker from './vue-ctk-date-time-picker.common.js';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker);

// 토글 컴포넌트 https://github.com/euvl/vue-js-toggle-button
import ToggleButton from 'vue-js-toggle-button';

Vue.use(ToggleButton);

// 체크박스(라디오버튼 등..) 컴포넌트
// https://hamed-ehtesham.github.io/pretty-checkbox-vue/
import PrettyCheckbox from 'pretty-checkbox-vue';

Vue.use(PrettyCheckbox);


// 화면분할(split) 라이브러리
// https://github.com/nathancahill/split/tree/master/packages/splitjs#usage-examples
import Split from 'split.js';

window.Split = Split;

// 이미지 줌 라이브러리
// https://mater1996.github.io/vue-photo-zoom-pro/guide/#image
// 필요시에 임포트해서 사용
// import VuePhotoZoomPro from 'vue-photo-zoom-pro'
// import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'

// range slider input 라이브러리
// https://github.com/mzusin/toolcool-range-slider
// 전역에서 <tc-range-slider></tc-range-slider> 선언되면 동작함.
import 'toolcool-range-slider';


//컴포넌트
Vue.component('app-clearance-no-checker', require('./components/app/clearance-no-checker/main.vue').default);


Vue.component('app-module-login', require('./components/app/module/login.vue').default);
Vue.component('app-module-password-reset-done', require('./components/app/module/password-reset-done.vue').default);

Vue.component('app-elem-input', require('./components/app/elem/input.vue').default);
Vue.component('app-elem-icon-link', require('./components/app/elem/icon-link.vue').default);
//Vue.component('app-elem-tr-packing', require('./components/app/elem/tr-packing.vue').default);
//Vue.component('app-elem-input-text', require('./components/app/elem/input-text.vue').default);
//Vue.component('app-elem-input-password', require('./components/app/elem/input-password.vue').default);
Vue.component('app-elem-logo', require('./components/app/elem/logo.vue').default);

Vue.component('app-shipping-reg-prod', require('./components/app/shipping-reg/prod.vue').default);
Vue.component('app-shipping-reg-house', require('./components/app/shipping-reg/house.vue').default);
Vue.component('app-shipping-reg-prod-list', require('./components/app/shipping-reg/prod-list.vue').default);
Vue.component('app-shipping-reg-fieldset', require('./components/app/shipping-reg/fieldset.vue').default);

Vue.component('app-stock-reg-prod', require('./components/app/stock-reg/prod.vue').default);
Vue.component('app-stock-reg-prod-list', require('./components/app/stock-reg/prod-list.vue').default);
Vue.component('app-stock-reg-fieldset', require('./components/app/stock-reg/fieldset.vue').default);

Vue.component('app-nuskin-in', require('./components/app/stock-amount-in/nuskin-in.vue').default);

// 새로작성된 input
//Vue.component('app-input-base', require('./components/app/input/common.vue').default);
Vue.component('app-input-text', require('./components/app/input/text.vue').default);
Vue.component('app-input-fixed', require('./components/app/input/fixed.vue').default);
Vue.component('app-input-select', require('./components/app/input/select.vue').default);
Vue.component('app-input-writable-select', require('./components/app/input/writable-select.vue').default);
Vue.component('app-input-search-select', require('./components/app/input/search-select.vue').default);
Vue.component('app-input-tag-select', require('./components/app/input/tag-select.vue').default);
Vue.component('app-input-radio', require('./components/app/input/radio.vue').default);
Vue.component('app-input-textarea', require('./components/app/input/textarea.vue').default);
//Vue.component('app-input', require('./components/app/input/bundle.vue').default);
Vue.component('app-input-ex', require('./components/app/input/ex/default.vue').default); // input 확장 - 기본 템플릿

// 레이아웃
Vue.component('app-layout-group', require('./components/app/layout/group.vue').default);

// 화면배율
Vue.component('app-screen-ratio', require('./components/app/common/screen-ratio.vue').default);

// 회원사 전체지역 정보
Vue.component('app-user-agent-info', require('./components/app/user/agent-info.vue').default);
Vue.component('app-user-update-user-role-cost', require('./components/app/user/update-user-role-cost.vue').default);

// 회원 운임정보설정
Vue.component('app-user-update-user-cost', require('./components/app/user/update-user-cost.vue').default);

// 비밀번호 재설정
Vue.component('app-user-reset-password', require('./components/app/user/reset-password.vue').default);

// 회원 입금확인요청
Vue.component('app-bank-deposit-request-create', require('./components/app/bank-deposit-request/create.vue').default);
Vue.component('app-bank-deposit-request-update', require('./components/app/bank-deposit-request/update.vue').default);

// 계좌거래내역
Vue.component('app-bank-transaction-manual-check', require('./components/app/bank-transaction/manual-check.vue').default);
Vue.component('app-bank-transaction-manual-match', require('./components/app/bank-transaction/manual-match.vue').default);

// 일괄기능 컴포넌트
Vue.component('app-batch-controller', require('./components/app/batch/controller.vue').default);
Vue.component('app-batch-item-checker', require('./components/app/batch/item-checker.vue').default);
Vue.component('app-batch-all-item-checker', require('./components/app/batch/all-item-checker.vue').default);
Vue.component('app-batch-job-sample', require('./components/app/batch/jobs/sample.vue').default);
Vue.component('app-batch-job-prod', require('./components/app/batch/jobs/prod/main.vue').default);
Vue.component('app-batch-job-prod-buy-price-sum', require('./components/app/batch/jobs/prod/buy-price-sum.vue').default);
// 구매요청 일괄 (TASK-161 — 사이클 12: 「기존 구매정보에 추가」 는 구매정보저장으로 통합 (39-⑪), 「구매요청 메뉴에서 제거」 신설 (39-⑥))
Vue.component('app-batch-job-buy-request-store-order', require('./components/app/batch/jobs/buy-request-store-order.vue').default);
Vue.component('app-batch-job-buy-request-remove', require('./components/app/batch/jobs/buy-request-remove.vue').default);
// 구매요청 일괄 「배송단계 변경」 (TASK-172 절 C — 배송조회 jobs/prod/main.vue 내부 등록 state.vue 를 단독 재사용)
Vue.component('app-batch-job-prod-state', require('./components/app/batch/jobs/prod/state.vue').default);
// 총괄 대금상환 정산 · 정산취소 일괄 (TASK-161 결정 27)
Vue.component('app-batch-job-cod-payment-settle', require('./components/app/batch/jobs/cod-payment-settle.vue').default);
Vue.component('app-batch-job-cod-payment-unsettle', require('./components/app/batch/jobs/cod-payment-unsettle.vue').default);
// 총괄 대금상환 정산확정 · 정산확정 취소 일괄 (TASK-161 사이클 14 결정 49)
Vue.component('app-batch-job-cod-payment-confirm', require('./components/app/batch/jobs/cod-payment-confirm.vue').default);
Vue.component('app-batch-job-cod-payment-unconfirm', require('./components/app/batch/jobs/cod-payment-unconfirm.vue').default);

Vue.component('app-batch-job-end', require('./components/app/batch/jobs/end.vue').default);
Vue.component('app-batch-job-shipout', require('./components/app/batch/jobs/shipout.vue').default);
Vue.component('app-batch-job-end-done', require('./components/app/batch/jobs/end-done.vue').default);
Vue.component('app-batch-job-shipout-done', require('./components/app/batch/jobs/shipout-done.vue').default);
Vue.component('app-batch-job-shipout-request', require('./components/app/batch/jobs/shipout-request.vue').default);
Vue.component('app-batch-job-shipout-request-done', require('./components/app/batch/jobs/shipout-request-done.vue').default);
Vue.component('app-batch-job-shipout-request-print-bl', require('./components/app/batch/jobs/shipout-request-print-bl.vue').default);
Vue.component('app-batch-job-shipout-request-print-worklist', require('./components/app/batch/jobs/shipout-request-print-worklist.vue').default);
Vue.component('app-batch-job-charge-shipout-cost', require('./components/app/batch/jobs/charge-shipout-cost/main.vue').default);
Vue.component('app-batch-job-charge-return-cost', require('./components/app/batch/jobs/charge-return-cost/main.vue').default);
Vue.component('app-batch-job-charge-shipping-center-cost', require('./components/app/batch/jobs/charge-shipping-center-cost/main.vue').default);
Vue.component('app-batch-job-customs-cost-input-remove', require('./components/app/batch/jobs/customs-cost-input/remove.vue').default);
Vue.component('app-batch-job-customs-cost-input-charge', require('./components/app/batch/jobs/customs-cost-input/charge.vue').default);
Vue.component('app-batch-job-tax-invoice', require('./components/app/batch/jobs/tax-invoice/main.vue').default);
Vue.component('app-batch-job-return-info', require('./components/app/batch/jobs/return-info/main.vue').default);
Vue.component('app-batch-job-ship-in', require('./components/app/batch/jobs/ship-in/main.vue').default);
Vue.component('app-batch-job-house', require('./components/app/batch/jobs/house/main.vue').default);
Vue.component('app-batch-job-bank-deposit-request', require('./components/app/batch/jobs/bank-deposit-request/main.vue').default);
// [TASK-148] 과금내역 > 미결제 과금건 선택 일괄 재결제
Vue.component('app-batch-job-billing-retry', require('./components/app/batch/jobs/billing-retry/main.vue').default);

// 해외주문상세 - 상품 일괄기능
Vue.component('app-batch-job-prod-in-order-detail', require('./components/app/batch/jobs/prod-in-order-detail/main.vue').default);

// 해외주문 - 주문하기 (상품선택
Vue.component('app-batch-job-prod-to-order-choice', require('./components/app/batch/jobs/prod-to-order-choice/main.vue').default);

// 폐기대상 선정작업 - 일괄작업
Vue.component('app-batch-job-prod-to-destroy', require('./components/app/batch/jobs/prod-to-destroy/main.vue').default);

// 폐기대상 - 일괄작업
Vue.component('app-batch-job-prod-in-destroy-target', require('./components/app/batch/jobs/prod-in-destroy-target/main.vue').default);

// 폐기요청 - 일괄작업
Vue.component('app-batch-job-prod-in-destroy-req', require('./components/app/batch/jobs/prod-in-destroy-req/main.vue').default);

// 고객문의 - 일괄작업
Vue.component('app-batch-job-qnas', require('./components/app/batch/jobs/qnas/main.vue').default);

// 창고문의 - 일괄작업
Vue.component('app-batch-job-work-requests', require('./components/app/batch/jobs/work-requests/main.vue').default);

// 수출허가서 - 일괄작업
Vue.component('app-batch-job-export-permits', require('./components/app/batch/jobs/export-permits/main.vue').default);

// 패키지(무게입력)
Vue.component('app-packages', require('./components/app/packages/main.vue').default);

// 포장옵션입력
Vue.component('app-packing-options', require('./components/app/PackingOptions.vue').default);

// 세금계산서 발행
Vue.component('app-tax-invoice-issue', require('./components/app/tax-invoice/issue.vue').default);
Vue.component('app-tax-invoice-update', require('./components/app/tax-invoice/update.vue').default);

// 커뮤니케이션-활동내역(댓글)
Vue.component('app-cm-activity-list', require('./components/app/communication/activity-list.vue').default);
Vue.component('app-cm-activity', require('./components/app/communication/activity.vue').default);

// 커뮤니케이션 - 할당변경
Vue.component('app-cm-allocate', require('./components/app/communication/allocate.vue').default);

// 커뮤니케이션 - 할당 원클릭 변경
Vue.component('app-cm-allocate-buttons', require('./components/app/communication/allocate-buttons.vue').default);

// 커뮤니케이션 - 상태 원클릭 변경
Vue.component('app-cm-state-buttons', require('./components/app/communication/state-buttons.vue').default);

// 커뮤니케이션 - 감시
Vue.component('app-cm-watch', require('./components/app/communication/watch.vue').default);

// 반품
Vue.component('app-return-done', require('./components/app/return/done.vue').default);

// 창고문의
Vue.component('app-work-req-state', require('./components/app/region-work-request/state.vue').default);
Vue.component('app-work-req-title', require('./components/app/region-work-request/title.vue').default);
Vue.component('app-work-req-content', require('./components/app/region-work-request/content.vue').default);
Vue.component('app-work-req-remove', require('./components/app/region-work-request/remove.vue').default);

// 고객문의
Vue.component('app-qna-has-done-kakao', require('./components/app/qna/has-done-kakao.vue').default);
Vue.component('app-qna-state', require('./components/app/qna/state.vue').default);
Vue.component('app-qna-title', require('./components/app/qna/title.vue').default);
Vue.component('app-qna-content', require('./components/app/qna/content.vue').default);
Vue.component('app-qna-remove', require('./components/app/qna/remove.vue').default);

// 공지사항
Vue.component('app-notice-title', require('./components/app/notice/title.vue').default);
Vue.component('app-notice-point', require('./components/app/notice/point.vue').default);
Vue.component('app-notice-type', require('./components/app/notice/type.vue').default);
Vue.component('app-notice-remove', require('./components/app/notice/remove.vue').default);

// FAQ
Vue.component('app-faq-title', require('./components/app/faq/title.vue').default);
Vue.component('app-faq-point', require('./components/app/faq/point.vue').default);
Vue.component('app-faq-highlight', require('./components/app/faq/highlight.vue').default);
Vue.component('app-faq-dashboard', require('./components/app/faq/dashboard.vue').default);
Vue.component('app-faq-type', require('./components/app/faq/type.vue').default);
Vue.component('app-faq-remove', require('./components/app/faq/remove.vue').default);

// 창고FAQ
Vue.component('app-warehouse-faq-title', require('./components/app/warehouse-faq/title.vue').default);
Vue.component('app-warehouse-faq-point', require('./components/app/warehouse-faq/point.vue').default);
Vue.component('app-warehouse-faq-type', require('./components/app/warehouse-faq/type.vue').default);
Vue.component('app-warehouse-faq-remove', require('./components/app/warehouse-faq/remove.vue').default);

// 발송작업
Vue.component('app-out', require('./components/app/out/main.vue').default);

// 출고요청
Vue.component('app-shipout-request-job', require('./components/app/shipout-request/job.vue').default);


// 파일
Vue.component('app-file-uploader', require('./components/app/file/uploader.vue').default);
Vue.component('app-file-upload-on-phone', require('./components/app/file/upload-on-phone.vue').default);
Vue.component('app-file-list', require('./components/app/file/list.vue').default);

// 칼럼
Vue.component('app-column', require('./components/app/column/column.vue').default);

// 마감
Vue.component('app-end-job', require('./components/app/end/job.vue').default);


// 출고
Vue.component('app-shipout-job', require('./components/app/shipout/job.vue').default);
Vue.component('app-shipout-set-offload', require('./components/app/shipout/set-offload.vue').default);
Vue.component('app-shipout-unset-offload', require('./components/app/shipout/unset-offload.vue').default);


// 상품추가
Vue.component('app-add-prod', require('./components/app/AddProd.vue').default);

// 팝업관리
Vue.component('app-popup-create', require('./components/app/popup/create.vue').default);
Vue.component('app-popup-update', require('./components/app/popup/update.vue').default);
Vue.component('app-popup-remove', require('./components/app/popup/remove.vue').default);

// 배송지비용
Vue.component('app-shipping-center-cost-create', require('./components/app/shipping-center-cost/create.vue').default);
Vue.component('app-shipping-center-cost-remove', require('./components/app/shipping-center-cost/remove.vue').default);

// 렉관리
Vue.component('app-rack-create', require('./components/app/rack/create.vue').default);
Vue.component('app-rack-remove', require('./components/app/rack/remove.vue').default);

// 긴급입고 관리
Vue.component('app-urgent-ship-in-create', require('./components/app/urgent-ship-in/create.vue').default);
Vue.component('app-urgent-ship-in-remove', require('./components/app/urgent-ship-in/remove.vue').default);

// 해외오더 결제방법
Vue.component('app-payment-method-create', require('./components/app/payment-method/create.vue').default);
Vue.component('app-payment-method-remove', require('./components/app/payment-method/remove.vue').default);

// 결제수단관리
Vue.component('app-payment-setting', require('./components/app/payment-setting/index.vue').default);

// 수기과금
Vue.component('app-manual-billing-charge', require('./components/app/billing/manual-charge.vue').default);
Vue.component('app-billing-retry', require('./components/app/billing/billing-retry.vue').default);
Vue.component('app-manual-resolve', require('./components/app/billing/manual-resolve.vue').default);

// [카카오 심사 증빙 캡처용 — 실기능 무관] 스마트로 인증결제창 진입 버튼
// 노출 조건: SYSTEM_MANAGER + APP_ENV=local (blade 조건부 + 서버 라우트 가드)
// 상세: app/Http/Controllers/Web/System/KakaoReviewCapture/README.md
Vue.component('app-kakao-review-auth-pay', require('./components/app/kakao-review-capture/auth-pay-button.vue').default);
Vue.component('app-charge-shipping-etc-cost', require('./components/app/billing/charge-shipping-etc-cost.vue').default);
Vue.component('app-charge-customs-cost', require('./components/app/billing/charge-customs-cost.vue').default);
Vue.component('app-charge-add-cost', require('./components/app/billing/charge-add-cost.vue').default);
Vue.component('app-charge-goods-cost', require('./components/app/billing/charge-goods-cost.vue').default);
Vue.component('app-charge-shipout-cost', require('./components/app/billing/charge-shipout-cost.vue').default);

// 해외오더
Vue.component('app-buy-order-create', require('./components/app/buy-order/create.vue').default);
Vue.component('app-buy-order-update', require('./components/app/buy-order/update.vue').default);
Vue.component('app-buy-order-remove', require('./components/app/buy-order/remove.vue').default);
Vue.component('app-buy-order-edit-layer', require('./components/app/buy-order/edit-layer.vue').default); // 구매요청 수정 레이어 (TASK-161)
Vue.component('app-buy-order-prod-cards', require('./components/app/buy-order/prod-cards.vue').default); // 구매정보 상품 목록 (TASK-161 사이클 13 — 사이클 16 #27 간략 행, 구매정보저장 · 수정 레이어 · 대금상환 모달 공용)
Vue.component('app-buy-order-ctx', require('./components/app/buy-order/ctx-head.vue').default); // 모달 컨텍스트 헤더 (TASK-161 사이클 16 #27 — 해외오더번호 · 트래킹 · 금액 키-값)
Vue.component('app-buy-order-charge-goods-cost', require('./components/app/buy-order/charge-goods-cost.vue').default); // 구매요청 물품가 과금 모달 (TASK-176 U6b)

// 대금상환 (TASK-161 ⓒ — 팝업은 페이지당 1 인스턴스, 행 버튼이 open(row) 로 데이터 주입)
Vue.component('app-cod-payment-paid-popup', require('./components/app/cod-payment/paid-popup.vue').default);
Vue.component('app-cod-payment-unpaid-popup', require('./components/app/cod-payment/unpaid-popup.vue').default);
Vue.component('app-cod-payment-correct-popup', require('./components/app/cod-payment/correct-popup.vue').default);
Vue.component('app-cod-payment-memo-popup', require('./components/app/cod-payment/memo-popup.vue').default); // 비고 2종 공용 모달 (결정 3 ⓒ → 사이클 14 #12)
Vue.component('app-cod-payment-confirm-popup', require('./components/app/cod-payment/confirm-popup.vue').default); // 건별 정산확정 (사이클 14 결정 49 f)
Vue.component('app-cod-payment-tracking-scan-input', require('./components/app/cod-payment/tracking-scan-input.vue').default);

// 입고내역 관리
Vue.component('app-ship-in-remove', require('./components/app/ship-in/remove.vue').default);

// 보관장소 임대장부
Vue.component('app-storage-lental-set-free', require('./components/app/storage-lental/set-free.vue').default);


// 검수요청사항 관리
Vue.component('app-check-request-create', require('./components/app/check-request/create.vue').default);
Vue.component('app-check-request-remove', require('./components/app/check-request/remove.vue').default);
Vue.component('app-check-request-update', require('./components/app/check-request/update.vue').default);
Vue.component('app-check-request-label', require('./components/app/check-request/label/default.vue').default);

// 검수작업 관련
Vue.component('app-check-request-list', require('./components/app/check/request-list.vue').default);
Vue.component('app-check-set-error', require('./components/app/check/set-error.vue').default);
Vue.component('app-check-set-hold', require('./components/app/check/set-hold.vue').default);
Vue.component('app-check-set-ok', require('./components/app/check/set-ok.vue').default);
Vue.component('app-check-packing', require('./components/app/check/packing/main.vue').default);
Vue.component('app-check-tracking-check', require('./components/app/check/tracking-check/main.vue').default);
Vue.component('app-check-one-prod', require('./components/app/check/tracking-check/check-one-prod.vue').default);
Vue.component('app-check-nodata', require('./components/app/check/nodata-stock/main.vue').default);

// 무자료 수동등록
Vue.component('app-nodata-simple-register', require('./components/app/nodata-simple-register/main.vue').default);

// 무자료확인(스캔)
Vue.component('app-nodata-scan', require('./components/app/nodata-scan/main.vue').default);

// 입고스캔
Vue.component('app-ship-in-scan', require('./components/app/ship-in/scan/main.vue').default);

// 오류정보
Vue.component('app-error-type', require('./components/app/error/type.vue').default);
Vue.component('app-error-return-label', require('./components/app/error/return-label.vue').default);
Vue.component('app-error-update', require('./components/app/error/update.vue').default);
Vue.component('app-error-not-arrival-to-reorder', require('./components/app/error/not-arrival-to-reorder.vue').default);
Vue.component('app-error-not-arrival-to-retracking', require('./components/app/error/not-arrival-to-retracking.vue').default);
Vue.component('app-error-not-arrival-to-cancel', require('./components/app/error/not-arrival-to-cancel.vue').default);
Vue.component('app-error-resolve-lack-amount', require('./components/app/error/resolve-lack-amount.vue').default);

// 재고처리
Vue.component('app-prod-to-stock-by-agent-member', require('./components/app/prod/to-stock-by-agent-member.vue').default);

// 반품처리
Vue.component('app-prod-to-return', require('./components/app/prod/to-return.vue').default);

// 발송처리
Vue.component('app-prod-to-out', require('./components/app/prod/to-out.vue').default);

// 취소
Vue.component('app-prod-to-cancel', require('./components/app/prod/to-cancel.vue').default);

// 구매요청 메뉴 노출설정 ON/OFF (TASK-161 사이클 12 결정 39-⑦ — 상품상세 관리자 추가버튼)
Vue.component('app-prod-buy-request-visibility', require('./components/app/prod/buy-request-visibility.vue').default);

// 삭제
Vue.component('app-prod-to-delete', require('./components/app/prod/to-delete.vue').default);

// 하우스 배달완료
Vue.component('app-house-to-receive', require('./components/app/house/to-receive.vue').default);

// 하우스 센터이동
Vue.component('app-house-change-center', require('./components/app/house/change-center.vue').default);

// 하우스 통관정보수정
Vue.component('app-house-change-customs-info', require('./components/app/house/change-customs-info.vue').default);

// [TASK-153] 하우스 통관정보 검사안함 설정 / 설정해지 (상세 버튼에서 직접 오픈)
Vue.component('app-house-ignore-customs-validation', require('./components/app/house/ignore-customs-validation.vue').default);
Vue.component('app-house-unignore-customs-validation', require('./components/app/house/unignore-customs-validation.vue').default);

// 하우스 통관정보 유효성
Vue.component('app-house-customs-validation', require('./components/app/house/customs-validation.vue').default);

// 폐기관련
Vue.component('app-prod-to-destroy-target', require('./components/app/prod/to-destroy-target.vue').default);
Vue.component('app-prod-to-destroy-req', require('./components/app/prod/to-destroy-req.vue').default);
Vue.component('app-prod-to-destroy-done', require('./components/app/prod/to-destroy-done.vue').default);
Vue.component('app-prod-destroy-to-stock', require('./components/app/prod/destroy-to-stock.vue').default);
Vue.component('app-prod-set-destroy-ignore', require('./components/app/prod/set-destroy-ignore.vue').default);
Vue.component('app-prod-unset-destroy-ignore', require('./components/app/prod/unset-destroy-ignore.vue').default);
Vue.component('app-prod-set-over_stored', require('./components/app/prod/set-over-stored.vue').default);
Vue.component('app-prod-unset-over_stored', require('./components/app/prod/unset-over-stored.vue').default);

// 제한관련
Vue.component('app-user-update-policy', require('./components/app/user/update-policy.vue').default);
Vue.component('app-user-set-restrict-register', require('./components/app/user/set-restrict-register.vue').default);
Vue.component('app-user-unset-restrict-register', require('./components/app/user/unset-restrict-register.vue').default);
Vue.component('app-user-set-restrict-shipout', require('./components/app/user/set-restrict-shipout.vue').default);
Vue.component('app-user-unset-restrict-shipout', require('./components/app/user/unset-restrict-shipout.vue').default);
Vue.component('app-user-refresh-restrict-policy', require('./components/app/user/refresh-restrict-policy.vue').default);
Vue.component('app-user-restrict-action', require('./components/app/user/restrict-action.vue').default);

// 재고상품 소유권 변경
Vue.component('app-prod-change-stock-owner', require('./components/app/prod/change-stock-owner.vue').default);

// 라벨 샘플
Vue.component('app-printer-bl-sample', require('./components/app/printer/bl-sample.vue').default);
Vue.component('app-printer-ship-in-label-sample', require('./components/app/printer/ship-in-label-sample.vue').default);

// 버튼
Vue.component('app-button-state-sync', require('./components/app/button/state-sync/common.vue').default);

// 시스템 진단
Vue.component('app-sync-diagnosis', require('./components/app/system/sync-diagnosis.vue').default);
Vue.component('app-error-log', require('./components/app/system/error-log.vue').default);

// 회원가입 약관동의
Vue.component('app-register-terms-agree', require('./components/app/register/terms-agree.vue').default);

// 회원가입 폼
Vue.component('app-register-form', require('./components/app/register/form.vue').default);

// 리스트의 검색영역
Vue.component('app-search-bar', require('./components/app/search-bar.vue').default);

// TASK-043 — 과금기준일 검색 필터 (과금타입별 인포 툴팁 동적 변경)
Vue.component('billing-date-filter', require('./components/app/billing-date-filter.vue').default);

// 배송단계별 수량집계
Vue.component('app-state-aggregate', require('./components/app/state-aggregate.vue').default);

// REF-034 (2026-05-26): REF-020 Phase 2-E 폐지 → app-header-nav 등록 복원 (옛 default + full-width 가 본 컴포넌트 사용)
Vue.component('app-header-nav', require('./components/app/header-nav.vue').default);

// REF-020 Phase 2-A·B·C·D + 2-H (2026-05-04) — 신규 헤더 SSOT Vue 컴포넌트 5종 (M3 δ 모두)
// REF-020 안건 66 (2026-05-12) — public-header 분리 (비로그인 전용)
Vue.component('app-header', require('./components/app/header.vue').default);
Vue.component('app-header-public', require('./components/app/public-header.vue').default);
Vue.component('app-subheader', require('./components/app/subheader.vue').default);
Vue.component('app-sidebar', require('./components/app/sidebar.vue').default);
Vue.component('app-page-header', require('./components/app/page-header.vue').default);
Vue.component('app-alert-bar', require('./components/app/alert-bar.vue').default);
// 안건 42 (2026-05-11): 상품상세 페이지 전용 헤딩 컴포넌트 (일반 page-header 와 분리)
Vue.component('app-prods-detail-header', require('./components/app/prods-detail-header.vue').default);

// 우편번호검색
Vue.component('app-zipcode-search', require('./components/app/zipcode/search.vue').default);

// 통관안내
Vue.component('app-customs-desc', require('./components/app/customs-desc.vue').default);

// 통관금액 환율변동주의 라벨 (TASK-150)
Vue.component('app-customs-usd-rate-warning', require('./components/app/customs-usd/rate-warning.vue').default);

// 이미지변경
Vue.component('app-prod-img-changer', require('./components/app/prod/img-changer.vue').default);

// 트래킹번호
Vue.component('app-prod-tracking-no', require('./components/app/prod/tracking-no.vue').default);

// 해외오더번호
Vue.component('app-prod-buy-order-code', require('./components/app/prod/buy-order-code.vue').default);

// 구매단가 인라인 수정 (TASK-161 구매요청)
Vue.component('app-prod-buy-unit-price', require('./components/app/prod/buy-unit-price.vue').default);

// hs코드
Vue.component('app-prod-hscode-on-edit', require('./components/app/prod/hscode/on-edit.vue').default);
Vue.component('app-prod-hscode-on-register', require('./components/app/prod/hscode/on-register.vue').default);
Vue.component('app-prod-hscode-on-addprod', require('./components/app/prod/hscode/on-addprod.vue').default);

// 안내라벨
Vue.component('app-guide-label-pack-type-none', require('./components/app/guide-label/pack-type-none.vue').default);
Vue.component('app-guide-label-user-market', require('./components/app/guide-label/user-market.vue').default);

// 오류라벨
Vue.component('app-error-label', require('./components/app/error/label/default.vue').default);

// 발송요청리스트 - 스캔(검색폼)
Vue.component('app-out-req-list-scan', require('./components/app/out-req-list/scan.vue').default);

// 게시판 컨텐츠
Vue.component('app-board-content', require('./components/app/board-content/main.vue').default);

// jodit 에디터
Vue.component('app-jodit', require('./components/app/jodit/default.vue').default);

// 지역설정
Vue.component('app-region-config-addr-sample', require('./components/app/region/config/addr-sample.vue').default);
Vue.component('app-region-config-center-notice', require('./components/app/region/config/center-notice.vue').default);
// TASK-125 (2026-08-15): 지역설정 1개 속성 편집 공용 컴포넌트 (config-name / title props). 신규 항목은 복제 대신 이걸 사용
Vue.component('app-region-config-attr-editor', require('./components/app/region/config/attr-editor.vue').default);

// 프린터설정
Vue.component('app-printer-setting', require('./components/app/printer/setting.vue').default);
Vue.component('app-printer-api', require('./components/app/printer/api/main.vue').default);

// 센터
Vue.component('app-center-default-shipping-cost', require('./components/app/center/default-shipping-cost.vue').default);

// 백그라운드 작업 현황
Vue.component('app-background-job-status', require('./components/app/system/background-job-status.vue').default);

// 더미데이터 생성기
Vue.component('app-dummy-data', require('./components/app/system/dummy-data.vue').default);

// 오버레이 화면 block
Vue.component('overlay-loading', require('./components/app/common/overlay-loading.vue').default);
Vue.component('loading-icon', require('./components/app/common/loading-icon.vue').default);

// 복사하기 컴포넌트
Vue.component('copy', require('./components/app/common/copy.vue').default);




// 뷰 옵션 확장
let cmp_id_seq = 0;
Vue.prototype = _.assignIn(Vue.prototype, {
    /**
     * 뷰객체(컴포넌트)에 대해서 유일한 아이디를 생성한다.
     * 뷰 객체별로 중복되지 않는 유일한 아이디를 부여하기위해 사용함.
     * 한 컴포넌트를 문서내에서 여러번사용할때 id 값을 주기위함.
     */
    cmp_id: null,
    generate_cmp_id: function () {
        cmp_id_seq++;
        let id_prefix = 'vue_cmp_';
        return id_prefix + cmp_id_seq;
    },
    get_cmp_id: function () {
        if (!this.cmp_id) this.cmp_id = this.generate_cmp_id();
        return this.cmp_id;
    },

    /**
     * 현재 페이지를 갱신한다
     */
    refreshPage: function () {
        $.app.refresh();
    },

    /**
     * dataurl 을 blob 객체로변환
     * @param dataurl
     * @returns {Blob}
     */
    dataURLtoBlob(dataurl) {
        let arr = dataurl.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], {type: mime});
    },

    /**
     * 기본 프린터API 컴포넌트 반환
     * @returns {Vue}
     */
    printerApi() {
        let api = window.app.$refs['printer-api'];
        if (! api) {
            throw new Error('프린터 API 컴포넌트를 찾을 수 없습니다.');
        }
        return api;
    },

});

//디렉티브 정의
/**
 * 텍스트 자식노드를 추가한다.
 *  - nl2br 적용해서 추가한다.
 */
Vue.directive('nl2br', function (el, binding, vnode, oldVnode) {
    // 엔터값 <br /> 태그로 전환
    let text = binding.value;
    if (!text) {
        text = '';
    }
    text = text.replace(/(?:\r\n|\r|\n)/g, '<br />');

    // 기존 자식노드 모두 삭제
    while (el.firstChild) {
        el.firstChild.remove();
    }

    // 새로 텍스트 자식노드 추가
    $(el).append(text);

});


/**
 * 숫자 콤마 포맷 전역 메서드 — TASK-149 (2026-09-20)
 *  - 템플릿: {{ $formatNumber(value, 2) }} / 스크립트: this.$formatNumber(value)
 *  - 구현 단일 출처 = utils/format-number.js (mixins/format-number.js 는 호환층)
 *  - v-comma-number 디렉티브(아래)는 소수 자릿수를 자르지 않는 기존 동작을 유지 (별도)
 */
import { formatNumber as formatNumberUtil } from './utils/format-number';
Vue.prototype.$formatNumber = formatNumberUtil;

/**
 * 텍스트 자식노드를 추가한다.
 *  - 컴마형태의 숫자로 값을 표현한다.
 *  - 숫자가 아닌 값은 공백처리
 */
Vue.directive('commaNumber', function (el, binding, vnode, oldVnode) {
    let num = binding.value;
    if (isNaN(num)) {
        num = '';
    } else {
        // 컴마처리
        let parts = num.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        num = parts.join(".");
    }

    // 기존 자식노드 모두 삭제
    while (el.firstChild) {
        el.firstChild.remove();
    }

    // 새로 텍스트 자식노드 추가
    $(el).append(num);

});

/**
 * 값이 비었으면 visibility 변경
 * v-show는 display 로 컨트롤해서 제작함.
 */
Vue.directive('visible', function (el, binding, vnode, oldVnode) {
    // `bind`와 `update`를 호출합니다.
    if (binding.value) {
        el.style.visibility = 'visible';
    } else {
        el.style.visibility = 'hidden';
    }
});

/**
 * 브라우저 탐지
 */
//import browser from './browser-detect';
//window.browser = browser;

/**
 * 검증규칙 추가
 */
// 소수 2자리 숫자규칙 추가
window.approve.addTest({
    message: '소수 2자리',
    validate: function (value, pars) {
        // 소수 2자리
        let regexp = /^\s*[0-9]+(\.[0-9]{1,2})?\s*$/ig;
        return regexp.test(value);
    }
}, 'dec2digit');
window.approve.addTest({
    message: '0.01 이상',
    validate: function (value, pars) {
        if (isNaN(value)) {
            return false;
        }
        value = parseFloat(value);
        return value >= 0.01;
    }
}, 'gteZeroPointZeroOne');
window.approve.addTest({
    message: '0 이상',
    validate: function (value, pars) {
        if (isNaN(value)) {
            return false;
        }
        value = parseFloat(value);
        return value >= 0;
    }
}, 'gteZero');

/**
 * 기본검증 오류메세지 수정
 */
window.approve.tests.numeric.message = "{title} 0-9 숫자만 가능";